/**
 * Created by dv on 9/21/2017.
 */
import {ApproveRejectCollectionMessage, ApproveRejectCollectionQuery} from "../../autogenerated/ZoomBridge";

export default class ApproveRejectCollection {
  /**
   * Creates a new object of the class to set the collection status
   * @param collectionId {Number} is the collection id for the collection to be approved or rejected.
   * @param approve {Boolean} if true means to approve the collection, reject if false.
   */
  constructor(collectionId, approve) {
    this._collectionId = collectionId;
    this._approve = approve;
  }

  /**
   * Set the approve status for the collection. True for collection approved, otherwise collection rejected
   * @return {ApproveRejectCollection}
   * @public
   */
  setApprove(approve) {
    this._approve = approve;
    return this;
  }

  /**
   * The response returned by the query is of type {SimpleResponse}
   * @public
   */
  run() {
    const message = new ApproveRejectCollectionMessage();
    message.setCollectionId(this._collectionId);
    message.setApprove(this._approve);

    const query = new ApproveRejectCollectionQuery();
    query.message = message;
    return query.run();
  }
}
